module.exports = __webpack_public_path__ + "img/nbc.3aad1892.svg";